import React from 'react';

import { Icon } from '../icons';

export const ManualOrderIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 17 16" fill={color} style={style}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.072 3C5.76447 3 5.52983 3.27499 5.57823 3.57869L6.02573 6.38654C6.05505 6.5705 6.21372 6.70588 6.4 6.70588C6.58629 6.70588 6.74496 6.5705 6.77428 6.38654L7.22178 3.57869C7.27018 3.27499 7.03554 3 6.72801 3H6.072ZM4.59069 3.73608C4.44549 2.82498 5.1494 2 6.072 2H6.72801C7.65061 2 8.35452 2.82498 8.20931 3.73608L7.76181 6.54392C7.65513 7.21329 7.07782 7.70588 6.4 7.70588C5.72219 7.70588 5.14487 7.21329 5.03819 6.54392L4.59069 3.73608Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.928 9.29413C11.2355 9.29413 11.4702 9.56912 11.4218 9.87282L10.9743 12.6807C10.945 12.8646 10.7863 13 10.6 13C10.4137 13 10.255 12.8646 10.2257 12.6807L9.77822 9.87282C9.72982 9.56912 9.96446 9.29413 10.272 9.29413H10.928ZM12.4093 10.0302C12.5545 9.11911 11.8506 8.29413 10.928 8.29413H10.272C9.34939 8.29413 8.64548 9.11911 8.79069 10.0302L9.23819 12.8381C9.34487 13.5074 9.92218 14 10.6 14C11.2778 14 11.8551 13.5074 11.9618 12.8381L12.4093 10.0302Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4.85297C2 4.57682 2.22386 4.35297 2.5 4.35297H4.9C5.17614 4.35297 5.4 4.57682 5.4 4.85297C5.4 5.12911 5.17614 5.35297 4.9 5.35297L2.5 5.35297C2.22386 5.35297 2 5.12911 2 4.85297ZM7.1 4.85297C7.1 4.57682 7.32386 4.35297 7.6 4.35297L14.5 4.35297C14.7761 4.35297 15 4.57682 15 4.85297C15 5.12911 14.7761 5.35297 14.5 5.35297L7.6 5.35297C7.32386 5.35297 7.1 5.12911 7.1 4.85297Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 11.1471C15 10.871 14.7761 10.6471 14.5 10.6471H12.1C11.8239 10.6471 11.6 10.871 11.6 11.1471C11.6 11.4232 11.8239 11.6471 12.1 11.6471H14.5C14.7761 11.6471 15 11.4232 15 11.1471ZM9.9 11.1471C9.9 10.871 9.67614 10.6471 9.4 10.6471H2.5C2.22386 10.6471 2 10.871 2 11.1471C2 11.4232 2.22386 11.6471 2.5 11.6471H9.4C9.67614 11.6471 9.9 11.4232 9.9 11.1471Z"
        />
      </g>
    </svg>
  );
};
